import styled from '@emotion/styled';
import { InputAlert } from '@tablecheck/tablekit-react';

export const ErrorsList = styled.ul`
  list-style-type: initial;
  padding-left: var(--spacing-l4);
`;

export const PasswordMismatchAlert = styled(InputAlert)`
  margin-top: 0;
`;
